import React, { Component } from 'react';
import { Grid, Container, Loader, Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import OrgUsersCardContainer from 'go/components/team/orgUsersCard/orgUsersCardContainer';
import { canViewTeamPage } from 'go/security/permissions';
import { Select } from 'app-ui-componentlibrary';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';
import REST from 'go/requests/rest';

export class _Organizations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      error: false,
      data: null,
      currentOrg: null,
    };
  }

  componentDidMount() {
    this.getOrganizations();
  }

  getOrganizations = () => {
    return REST.user
      .getEntities(this.props.token)
      .then((response) => {
        if (response.ok) {
          // todo, replace with REST.handler.handleResponse or make custom REST.handler method
          return response.json();
        } else if (response.status === 404) {
          return [];
        } else {
          this.setState({ error: true, loading: false });
        }
      })
      .then((res) => {
        if (res) {
          this.setState({
            data: res,
            loading: false,
          });
        }
      })
      .catch((err) => {
        console.error('error');
        this.setState({
          error: true,
          loading: false,
        });
      });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ currentOrg: parseInt(value) });
  };

  render() {
    const { data, currentOrg, loading, error } = this.state;
    if (loading) {
      return <Loader active />;
    } else if (error) {
      return <Error />;
    } else if (data && data.length === 0) {
      return (
        <Grid key="noOrgGrid" doubling stackable reversed="mobile" padded="vertically">
          <Grid.Row>
            <Grid.Column>
              <Segment basic textAlign="center">
                <h2>
                  You must first belong to an organization to see organization
                  information.
                </h2>
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    } else if (data) {
      let orgHeading,
        displayOrg = null;
      if (currentOrg) displayOrg = currentOrg;
      if (!displayOrg)
        displayOrg = this.props.match.params.orgId
          ? parseInt(this.props.match.params.orgId)
          : data[0].entityId;

      if (data.length === 1) orgHeading = <h1>{data[0].displayName}</h1>;
      else if (data.length > 1) {
        const options = _.map(data, (entry) => {
          return { value: entry.entityId, text: entry.displayName };
        });
        orgHeading = (
          <React.Fragment>
            <label for="orgSelect">Select an organization</label>
            <Select
              title=""
              label=""
              id={'orgSelect'}
              name={'orgSelect'}
              options={options}
              value={displayOrg}
              handleChange={this.handleChange}
              className={'selectHeader'}
            />
          </React.Fragment>
        );
      }

      return (
        <Main>
          <Container>
            {orgHeading}
            {canViewTeamPage(this.props.permissions) && (
              <OrgUsersCardContainer userId={this.props.id} token={this.props.token} />
            )}
          </Container>
        </Main>
      );
    }
  }
}

export const mapStateToProps = (state) => {
  return {
    id: state.auth.userId,
    token: state.auth.token,
    permissions: state.auth.permissions,
  };
};

const Organizations = connect(mapStateToProps, null)(_Organizations);

export default Organizations;
